import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataDictionaryObjectNamesAsyncSlice } from './get';

export const coreDataDictionaryObjectNamesReducers = combineReducers({
	get: getCoreDataDictionaryObjectNamesAsyncSlice.asyncReducers
});

export const coreDataDictionaryObjectNamesWatchers = combineAllWatchers([
	getCoreDataDictionaryObjectNamesAsyncSlice.asyncWatchers
]);
